import { toast } from "react-toastify";
import {
  auth
} from "../../firebase";
import { signInWithPopup } from "firebase/auth";

export const handleSocialLogin = async (provider) => {
  try {
    const result = await signInWithPopup(auth, provider);
    const user = result.user;
    console.log("Utilisateur connecté :", user);
    // TODO: envoyer au backend ou rediriger
    return user;
  } catch (error) {
    console.error("Erreur de connexion :", error);
    toast.error("Echec de connexion avec Google.")
  }
};
